import CustomField from './CustomField';
import { getHtmlId, getHtmlName } from './utils/CustomFieldHelpers';
import React from 'react';
import { FsHeading } from '@finalsite/wc-react';
import { SubmitLinks } from './SubmitLinks';

/*
Form body component for Fusion Forms.  Renders the fields for the current page, as well as the page title and submit links.
@param form - the form object, which contains the template and pages
@param page - the current page number (1-indexed)
@param onChange - function to call when a field changes
@param setFieldValue - Tracks the value of a field in global form-wide state
@param getFieldValue - Get the value of any field based on its mapped name

 */
export const Body = ({watch, form, page, onChange, setFieldValue, getFieldValue, useDependency}) => {
  const pageObj = form.template.pages[page - 1];

  return <div className={'form-body'}>
    <FsHeading type={'title2'}> {pageObj?.name || `Page ${page}`}</FsHeading>

    {pageObj.custom_fields.map((field, index) => {
      const htmlName = getHtmlName(field, form);

      return <CustomField
        key={getHtmlId(field, form, index)}
        id={getHtmlId(field, form, index)}
        name={htmlName}

        {...{getFieldValue, setFieldValue, useDependency}}

        form={form}
        field={field}
        index={index}
      />;
    })}

    <SubmitLinks form={form} page={page}/>
  </div>;
}
